/**
 * Constants for radio configuration
 */

export const mono = {
  frequencyInterval: {
    868: { min: 863, max: 873 },
    915: { min: 902, max: 928 },
    923: { min: 915, max: 928 }
  },
  radioBandwidth: 0.8,
  multiSfBandwidth: 0.125
}

export const multi = {
  chipBandwidthMhz: 3,
  multiSfBandwidth: 0.125
}

// Export module
export default { mono, multi }
